import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Client, ClientWithRelations} from '../../../../@backend';
import {getClientDisplayName, getClientSecondaryLine} from '../../utils/client-utils';

@Component({
  selector: 'canvas-client-extended',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span>{{ displayName(client) }}</span>
    @if(secondaryLine(client)) {
      <div class="font-light text-sm">{{ secondaryLine(client) }}</div>
    }
    @if(client?.phone_1) {
      <div class="font-light text-sm">{{client.phone_1}}</div>
    }
    @if(client?.phone_2) {
      <div class="font-light text-sm">{{client.phone_2}}</div>
    }
    @if(client?.email_1) {
      <div class="font-light text-sm">{{client.email_1}}</div>
    }
    @if(client?.email_2) {
      <div class="font-light text-sm">{{client.email_2}}</div>
    }
  `
})
export class ClientExtendedComponent {
  @Input() client: Client | ClientWithRelations | any;
  @Input() enableLink: boolean = false;

  displayName(client: Client | ClientWithRelations | any): string {
    return getClientDisplayName(client);
  }

  secondaryLine(client: Client | ClientWithRelations | any): string {
    return getClientSecondaryLine(client);
  }
}
